<template>
  <form>
    <ul class="nav nav-tabs mt-3 ps-3 pe-3" v-if="isAdmin">
      <li v-for="(value, tab) in Tabs" class="nav-item">
        <a class="nav-link pe-2 ps-2" :class="{active: activeTab === tab}" @click.prevent="activeTab = tab" aria-current="page" href="#">
          {{ $t(`store_form.tabs.${value}`) }}
        </a>
      </li>
    </ul>
    <div class="row mb-2 p-3">
      <div class="col-sm-12">
        <div :class="activeTab !== Tabs.main ? ['d-none'] : []">
          <div class="row mt-2" v-if="isAdmin">
            <label for="is_active" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.is_active") }}</label>
            <div class="col-sm-8 d-flex align-items-center">
              <div class="form-check form-switch ">
                <input  v-model="form.isActive" class="form-check-input" type="checkbox" id="is_active">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isPayInBlocked" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isPayInBlocked") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input  v-model="form.isPayInBlocked" class="form-check-input" type="checkbox" id="isPayInBlocked">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isPayOutBlocked" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isPayOutBlocked") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input  v-model="form.isPayOutBlocked" class="form-check-input" type="checkbox" id="isPayOutBlocked">
              </div>
            </div>
          </div>


          <div class="row mt-2">
            <label for="name" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.name") }}</label>
            <div class="col-sm-8">
              <input v-model="form.name" type="text" class="form-control " id="name">
            </div>
          </div>

          <div class="row mt-2">
            <label for="currency" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.currency") }}</label>
            <div class="col-sm-8">
              <Multiselect id="currency"
                           class=""
                           v-model="form.currency"
                           :options="store.getters['currencyMethods/currencies']"
                           :custom-label="(opt) => `${opt}`"
                           :multiple="false"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="dealTimeOutMin" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.dealTimeOutMin") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]" class="row">
                <div class="col-sm-3" :class="parentProps.class">
                  <input v-model="form.dealTimeOutMin" type="text" class="form-control " id="dealTimeOutMin"
                         v-maska
                         data-maska="99"
                         data-maska-tokens="9:[0-9]:optional"
                         :class="parentProps.class"
                  >
                </div>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="minInvoiceAmount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.min_pay_in_amount") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]" class="row">
                <div class="col-sm-3" :class="parentProps.class">
                  <input v-model="form.minPayInAmount" type="text" class="form-control " id="minInvoiceAmount"
                         v-maska
                         data-maska="9 99#"
                         data-maska-tokens="9:[0-9]:repeated"
                         data-maska-reversed
                         :class="parentProps.class"
                  >
                </div>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="maxInvoiceAmount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.max_pay_in_amount") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]" class="row">
                <div class="col-sm-3" :class="parentProps.class">
                  <input v-model="form.maxPayInAmount" type="text" class="form-control " id="maxInvoiceAmount"
                         v-maska
                         data-maska="9 99#"
                         data-maska-tokens="9:[0-9]:repeated"
                         data-maska-reversed
                         :class="parentProps.class"
                  >
                </div>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="minPayOutAmount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.min_pay_out_amount") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]" class="row">
                <div class="col-sm-3" :class="parentProps.class">
                  <input v-model="form.minPayOutAmount" type="text" class="form-control " id="minPayOutAmount"
                         v-maska
                         data-maska="9 99#"
                         data-maska-tokens="9:[0-9]:repeated"
                         data-maska-reversed
                         :class="parentProps.class"
                  >
                </div>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="maxPayOutAmount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.max_pay_out_amount") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]" class="row">
                <div class="col-sm-3" :class="parentProps.class">
                  <input v-model="form.maxPayOutAmount" type="text" class="form-control " id="maxPayOutAmount"
                         v-maska
                         data-maska="9 99#"
                         data-maska-tokens="9:[0-9]:repeated"
                         data-maska-reversed
                         :class="parentProps.class"
                  >
                </div>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="payInRequestLimitPercent" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payInRequestLimitPercent") }}</label>
            <div class="col-sm-8">
              <div class="row">
                <small class="text-secondary ms-2">0% - отключить выдачу, 100% - без ограничений</small>
              </div>

              <div class="row mb-1" v-for="(limit, index) in form.payInRequestLimits" :key="index">
                <div class="col-sm-8 pe-2">
                  <Multiselect
                      class="multiselect-sm"
                      v-model="limit.option"
                      :options="store.getters['currencyMethods/options']()"
                      :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                      select-label="Select"
                      placeholder=""
                      open-direction="bottom"
                      :multiple="false"
                      :searchable="true"
                      :internal-search="true"
                      :clear-on-select="true"
                      :close-on-select="true"
                      :options-limit="100"
                      :limit="1000"
                      :show-no-results="false"
                      :hide-selected="true"
                  >
                  </Multiselect>
                </div>
                <div class="col-sm-2">
                  <input v-model="limit.value" type="text" class="form-control form-control-sm"
                         v-maska
                         data-maska="999"
                         data-maska-tokens="9:[0-9]:optional"
                  >
                </div>
                <div class="col-sm-2 ps-2">
                  <button type="button"  @click.prevent="removeLimit(index)" class="btn btn-sm btn-outline-danger text-nowrap"><i class="fa fa-trash"></i></button>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-10">
                  <button type="button" @click.prevent="addLimit()" class="btn w-100 btn-sm btn-outline-dark text-capitalize-first text-nowrap">{{helper.trans('button.add')}}</button>
                </div>
              </div>

            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin && payInRequestLimitsByAmountEnabled">
            <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payInRequestLimitByAmount") }}</label>
            <div class="col-sm-8">
              <div class="row">
                <small class="text-secondary ms-2">{{ helper.trans("labels.payInRequestLimitByAmountHint") }}</small>
              </div>

              <div class="row mb-1" v-for="(range, index) in form.payInRequestLimitsByAmount" :key="'amount-limit-' + index">
                <div class="col-sm-3 pe-1">
                  <input v-model="range.minSum" type="text" class="form-control form-control-sm" :placeholder="helper.trans('labels.amountFrom')">
                </div>
                <div class="col-sm-3 px-1">
                  <input v-model="range.maxSum" type="text" class="form-control form-control-sm" :placeholder="helper.trans('labels.amountTo')">
                </div>
                <div class="col-sm-3 px-1">
                  <input v-model="range.value" type="text" class="form-control form-control-sm"
                         v-maska
                         data-maska="999"
                         data-maska-tokens="9:[0-9]:optional"
                  >
                </div>
                <div class="col-sm-3 ps-1">
                  <button type="button" @click.prevent="removePayInRequestLimitByAmount(index)" class="btn btn-sm btn-outline-danger text-nowrap"><i class="fa fa-trash"></i></button>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-10">
                  <button type="button" @click.prevent="addPayInRequestLimitByAmount()" class="btn w-100 btn-sm btn-outline-dark text-capitalize-first text-nowrap">{{helper.trans('button.add')}}</button>
                </div>
              </div>
            </div>
          </div>

          <template v-if="canManageIssuanceAlert">
            <div class="row mt-3">
              <label for="issuanceTimeAlertEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans('store.issuance_time_alert.enabled') }}</label>
              <div class="col-sm-8 d-flex align-items-center">
                <div class="form-check form-switch mb-0">
                  <input
                    v-model="form.issuanceTimeAlertEnabled"
                    class="form-check-input"
                    type="checkbox"
                    id="issuanceTimeAlertEnabled"
                  >
                </div>
              </div>
            </div>

            <template v-if="form.issuanceTimeAlertEnabled">
              <div class="row mt-2">
                <label for="issuanceTimeAlertCriticalMilliseconds" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans('store.issuance_time_alert.critical_time') }}</label>
                <div class="col-sm-8">
                  <FormInputWrapper v-slot="parentProps" :errors="getIssuanceAlertErrors('issuanceTimeAlertCriticalMilliseconds')">
                    <input
                      v-model="form.issuanceTimeAlertCriticalMilliseconds"
                      type="text"
                      class="form-control"
                      id="issuanceTimeAlertCriticalMilliseconds"
                      :class="parentProps.class"
                      style="max-width: 140px"
                      placeholder="10000"
                    >
                  </FormInputWrapper>
                </div>
              </div>

              <div class="row mt-2">
                <label for="issuanceTimeAlertTgChatId" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans('store.issuance_time_alert.tg_chat_id') }}</label>
                <div class="col-sm-8">
                  <FormInputWrapper v-slot="parentProps" :errors="getIssuanceAlertErrors('issuanceTimeAlertTgChatId')">
                    <input
                      v-model="form.issuanceTimeAlertTgChatId"
                      type="text"
                      class="form-control"
                      id="issuanceTimeAlertTgChatId"
                      :class="parentProps.class"
                      @input="markIssuanceTimeAlertTgChatIdDirty"
                    >
                  </FormInputWrapper>
                </div>
              </div>
            </template>
          </template>

          <div class="row mt-3 mb-2" v-if="isAdmin && form.referralSettings && form.referralSettings.length > 0">
            <div class="col-sm-12 d-flex justify-content-start">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm text-capitalize-first"
                @click.prevent="$emit('open-referral-settings')"
              >
                {{ helper.trans('labels.referral_store_fees') }}
                <span v-if="referralOverridesCount > 0" class="badge bg-secondary ms-1">{{ referralOverridesCount }}</span>
              </button>
            </div>
          </div>

          <div class="row mt-3 mb-2" v-if="isAdmin && form.id">
            <div class="col-sm-12 d-flex justify-content-start">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm text-capitalize-first"
                @click.prevent="$emit('open-settings-history')"
              >
                {{ helper.trans('labels.settings_history') }}
              </button>
            </div>
          </div>
        </div>

        <div :class="activeTab !== Tabs.config ? ['d-none'] : []">
          <div class="row mt-2" v-if="isAdmin && integrationNames.length > 0">
            <label for="integrationName" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.integrationName") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]">
                <Multiselect id="integrationName"
                             class=""
                             :class="parentProps.class"
                             v-model="form.integrationName"
                             :options="integrationNames"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <div class="col-sm-12">
            <textarea ref="configField" id="config" class="form-control" rows="18">
            </textarea>
            </div>
          </div>
        </div>

        <div :class="activeTab !== Tabs.rates ? ['d-none'] : []">
          <div class="row mt-2" v-if="isAdmin">
            <label for="payInFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_in_fee_percent") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]" class="row">
                <div class="col-sm-3" :class="parentProps.class">
                  <input v-model="form.payInFee" type="text" class="form-control " id="payInFee"
                         v-maska
                         data-maska="99.99"
                         data-maska-tokens="9:[0-9]:optional"
                         :class="parentProps.class"
                  >
                </div>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin && geoFeeEnabled">
            <label for="payInFeeByPaymentOption" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payInFeeByPaymentOption") }}</label>
            <div class="col-sm-8">
              <div class="row mb-1" v-for="(row, index) in form.payInFeeByPaymentOption ?? []" :key="index">
                <div class="col-sm-8 pe-2">
                  <Multiselect
                      class="multiselect-sm"
                      v-model="row.option"
                      :options="store.getters['currencyMethods/options']()"
                      :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                      select-label="Select"
                      placeholder=""
                      open-direction="bottom"
                      :multiple="false"
                      :searchable="true"
                      :internal-search="true"
                      :clear-on-select="true"
                      :close-on-select="true"
                      :options-limit="100"
                      :limit="1000"
                      :show-no-results="false"
                      :hide-selected="true"
                  >
                  </Multiselect>
                </div>
                <div class="col-sm-2">
                  <input v-model="row.feePercent" type="text" class="form-control form-control-sm"
                         v-maska
                         data-maska="99.99"
                         data-maska-tokens="9:[0-9]:optional"
                  >
                </div>
                <div class="col-sm-2 ps-2">
                  <button type="button" @click.prevent="removePayInFeeOption(index)" class="btn btn-sm btn-outline-danger text-nowrap"><i class="fa fa-trash"></i></button>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-10">
                  <button type="button" @click.prevent="addPayInFeeOption()" class="btn w-100 btn-sm btn-outline-dark text-capitalize-first text-nowrap">{{helper.trans('button.add')}}</button>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="payOutFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_out_fee_percent") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]" class="row">
                <div class="col-sm-3" :class="parentProps.class">
                  <input v-model="form.payOutFee" type="text" class="form-control " id="payOutFee"
                         v-maska
                         data-maska="99.99"
                         data-maska-tokens="9:[0-9]:optional"
                         :class="parentProps.class"
                  >
                </div>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="payInRateSource" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.rate_source") }}, in</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]">
                <Multiselect id="parentId"
                             class=""
                             :class="parentProps.class"
                             v-model="form.payInRateSource"
                             :options="store.getters['rateSources/all']"
                             :custom-label="(opt: any) => store.getters['rateSources/get'](opt)?.name"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="payOutRateSource" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.rate_source") }}, out</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]">
                <Multiselect id="parentId"
                             class=""
                             :class="parentProps.class"
                             v-model="form.payOutRateSource"
                             :options="store.getters['rateSources/all']"
                             :custom-label="(opt: any) => store.getters['rateSources/get'](opt)?.name"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="payOutFixedRate" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.fixedRate") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]" class="row">
                <div class="col-sm-3" :class="parentProps.class">
                  <input v-model="form.payOutFixedRate" type="text" class="form-control " id="payOutFixedRate"
                         :class="parentProps.class"
                  >
                </div>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="payInRateShift" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payInRateShift") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]" class="row">
                <div class="col-sm-3" :class="parentProps.class">
                  <input v-model="form.payInRateShift" type="text" class="form-control " id="payInRateShift"
                         v-maska
                         data-maska="99.99"
                         data-maska-tokens="9:[0-9]:optional"
                         :class="parentProps.class"
                  >
                </div>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="traderPayInRateSource" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.trader_rate_source") }}, in</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]">
                <Multiselect id="parentId"
                             class=""
                             :class="parentProps.class"
                             v-model="form.traderPayInRateSource"
                             :options="store.getters['rateSources/all']"
                             :custom-label="(opt: any) => store.getters['rateSources/get'](opt)?.name"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>


          <div class="row mt-2" v-if="isAdmin">
            <label for="traderPayOutRateSource" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.trader_rate_source") }}, out</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]">
                <Multiselect id="parentId"
                             class=""
                             :class="parentProps.class"
                             v-model="form.traderPayOutRateSource"
                             :options="store.getters['rateSources/all']"
                             :custom-label="(opt: any) => store.getters['rateSources/get'](opt)?.name"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-3 mb-2" v-if="isAdmin">
            <div class="col-sm-12 d-flex justify-content-start">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm text-capitalize-first"
                @click.prevent="$emit('open-cross-border-rates')"
              >
                {{ helper.trans('labels.crossBorderRates') }}
                <span v-if="form.crossBorderSettings?.length" class="badge bg-secondary ms-1">{{ form.crossBorderSettings.length }}</span>
              </button>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="trafficGroups" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.traffic_groups") }}</label>
          </div>
          <div v-if="isAdmin" class="row mt-2 mb-4">
            <div class="col-sm-12">
              <div class="row">
                <label class="col-sm-6 col-form-label text-capitalize-first">{{helper.trans('labels.title')}}</label>
                <label class="col-sm-2 col-form-label text-capitalize-first">{{helper.trans('labels.fee')}}</label>
                <label class="col-sm-4 col-form-label text-capitalize-first text-center">{{helper.trans('labels.actions')}}</label>
              </div>

              <div class="row mb-1" v-for="(item, index) in form.trafficGroups" :key="index">
                <div class="col-sm-6 pe-2">
                  <Multiselect
                      class="multiselect-sm"
                      v-model="item.trafficGroup"
                      track-by="id"
                      :options="store.getters['trafficGroups/list']"
                      :custom-label="(opt) => `${opt.type}: ${opt.name}${opt.publicName ? ` (${opt.publicName})` : ''}`"
                      select-label="Select"
                      placeholder=""
                      open-direction="bottom"
                      :multiple="false"
                      :searchable="true"
                      :internal-search="true"
                      :clear-on-select="true"
                      :close-on-select="true"
                      :options-limit="100"
                      :limit="1000"
                      :show-no-results="false"
                      :hide-selected="true"
                  >
                  </Multiselect>
                </div>
                <div class="col-sm-2 pe-2">
                  <input v-if="item.trafficGroup?.type === Direction.PAY_IN" v-model="form.payInFee" readonly type="text" class="form-control form-control-sm"
                         v-maska
                         data-maska="99.99"
                         data-maska-tokens="9:[0-9]:optional"
                  >
                  <input v-else v-model="item.fee" :readonly="item.trafficGroup?.type !== Direction.PAY_OUT" type="text" class="form-control form-control-sm"
                         v-maska
                         data-maska="99.99"
                         data-maska-tokens="9:[0-9]:optional"
                  >
                </div>
                <div class="col-sm-4">
                  <div class="d-flex justify-content-between">
                    <button type="button" @click.prevent="toggleRanges(index)" class="btn btn-sm btn-outline-secondary text-nowrap me-2">
                      <i :class="expandedRanges[index] ? 'fa fa-eye-slash' : 'fa fa-eye'"></i> {{helper.trans('labels.ranges')}}
                    </button>

                    <button type="button" @click.prevent="removeTrafficGroup(index)" class="btn btn-sm btn-outline-danger text-nowrap"><i class="fa fa-trash"></i></button>
                  </div>

                </div>
                <div v-if="expandedRanges[index]" class="col-sm-12">
                  <div class="card card-body p-2 rounded-3 mt-2 mb-2">
                    <div class="row">
                      <div class="col-sm-4">
                        <label class="form-label text-capitalize-first">{{helper.trans('labels.min_sum')}}</label>
                      </div>
                      <div class="col-sm-4">
                        <label class="form-label text-capitalize-first">{{helper.trans('labels.max_sum')}}</label>
                      </div>
                      <div class="col-sm-3">
                        <label class="form-label text-capitalize-first">{{helper.trans('labels.fee')}}</label>
                      </div>
                      <div class="col-sm-1">
                      </div>
                    </div>

                    <div class="row mb-1" v-for="(range, rangeIndex) in item.feeByDealAmount" :key="rangeIndex">
                      <div class="col-sm-4 pe-2">
                        <input v-model="range.minSum" type="text" class="form-control form-control-sm"
                               :class="{'is-invalid': !isRangeValid(range)}"
                               :placeholder="helper.trans('labels.min_sum')">
                      </div>
                      <div class="col-sm-4 pe-2">
                        <input v-model="range.maxSum" type="text" class="form-control form-control-sm"
                               :class="{'is-invalid': !isRangeValid(range)}"
                               :placeholder="helper.trans('labels.max_sum')">
                      </div>
                      <div class="col-sm-3 pe-2">
                        <input :value="range._feePercent" @input="updateRangeField(index, rangeIndex, '_feePercent', $event.target.value)" type="text" class="form-control form-control-sm"
                               :class="{'is-invalid': !isRangeValid(range)}"
                               v-maska
                               data-maska="99.99"
                               data-maska-tokens="9:[0-9]:optional"
                               :placeholder="helper.trans('labels.fee')">
                      </div>
                      <div class="col-sm-1 text-end">
                        <button type="button" @click.prevent="removeRange(index, rangeIndex)" class="btn btn-sm btn-outline-danger">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <button type="button" @click.prevent="addRange(index)" class="w-100 btn btn-sm btn-outline-primary text-capitalize-first">
                          {{ helper.trans('button.add_range') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-1">
                <div class="col-sm-12">
                  <button type="button" @click.prevent="addTrafficGroup()" class="btn w-100 btn-sm btn-outline-dark text-capitalize-first text-nowrap">{{helper.trans('button.add')}}</button>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div :class="activeTab !== Tabs.payouts ? ['d-none'] : []">

          <div class="row mt-2" v-if="isAdmin">
            <label for="payOutDealLifetimeTimeout" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payOutDealLifetimeTimeout") }}</label>
            <div class="col-sm-4">
              <input v-model="form.payOutDealLifetimeTimeout" type="text" class="form-control" id="payOutDealLifetimeTimeout" placeholder="PT60M">
              <small class="form-text text-muted">Пример: PT60M</small>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isStrictPayOutDealLifetime" class="col-sm-4 col-form-label text-capitalize-first">
              {{ helper.trans("labels.isStrictPayOutDealLifetime") }}
            </label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input
                  v-model="form.isStrictPayOutDealLifetime"
                  class="form-check-input"
                  type="checkbox"
                  id="isStrictPayOutDealLifetime"
                >
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="payOutDealAcceptTimeout" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payOutDealAcceptTimeout") }}</label>
            <div class="col-sm-4">
              <input v-model="form.payOutDealAcceptTimeout" type="text" class="form-control" id="payOutDealAcceptTimeout" placeholder="PT5M">
              <small class="form-text text-muted">Пример: PT5M</small>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="payOutDealDisputeTimeout" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payOutDealDisputeTimeout") }}</label>
            <div class="col-sm-4">
              <input v-model="form.payOutDealDisputeTimeout" type="text" class="form-control" id="payOutDealDisputeTimeout" placeholder="PT30M">
              <small class="form-text text-muted">Пример: PT30M</small>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin && payOutDealSlaFeatureEnabled">
            <label for="payOutDealSla" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payOutDealSla") }}</label>
            <div class="col-sm-8">
              <textarea
                v-model="form.payOutDealSla"
                class="form-control"
                id="payOutDealSla"
                rows="6"
                maxlength="4000"
              ></textarea>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isSingleTakePayOutEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isSingleTakePayOutEnabled") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isSingleTakePayOutEnabled" class="form-check-input" type="checkbox" id="isSingleTakePayOutEnabled">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="payoutHolderNameHidden" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payoutHolderNameHidden") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isPayoutHolderNameHidden" class="form-check-input" type="checkbox" id="payoutHolderNameHidden">
              </div>
            </div>
          </div>

        </div>

        <div :class="activeTab !== Tabs.api ? ['d-none'] : []">
          <div class="row mt-2" v-if="isAdmin">
            <label for="maxBoundSumForUniqueSums" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.maxBoundSumForUniqueSums") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]">
                <input v-model="form.maxBoundSumForUniqueSums" type="text" class="form-control"  id="maxBoundSumForUniqueSums">
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="reusablePaymentsCountLimit" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.reusablePaymentsCountLimit") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]">
                <div class="col-sm-3 p-0" :class="parentProps.class">
                  <input
                    v-model="form.reusablePaymentsCountLimit"
                    type="text"
                    class="form-control"
                    id="reusablePaymentsCountLimit"
                    v-maska
                    data-maska="99999"
                    data-maska-tokens="9:[0-9]:optional"
                    :class="parentProps.class"
                  >
                </div>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isWebhooksEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isWebhooksEnabled") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input  v-model="form.isWebhooksEnabled" class="form-check-input" type="checkbox" id="isWebhooksEnabled">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isExpiredInvoiceWebhookEnabled" class="col-sm-4 col-form-label text-capitalize-first">
              {{ helper.trans("labels.isExpiredInvoiceWebhookEnabled") }}
            </label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input
                  v-model="form.isExpiredInvoiceWebhookEnabled"
                  class="form-check-input"
                  type="checkbox"
                  id="isExpiredInvoiceWebhookEnabled"
                  :disabled="!form.isWebhooksEnabled"
                >
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isDeeplinksEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isDeeplinksEnabled") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input  v-model="form.isDeeplinksEnabled" class="form-check-input" type="checkbox" id="isDeeplinksEnabled">
              </div>
              <small class="form-text text-muted">{{ helper.trans("labels.isDeeplinksEnabledHint") }}</small>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="allowDuplicateInvoices" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.allowDuplicateInvoices") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.allowDuplicateInvoices" class="form-check-input" type="checkbox" id="allowDuplicateInvoices" :true-value="true" :false-value="false">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="signatureRequired" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.signatureRequired") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input  v-model="form.signatureRequired" class="form-check-input" type="checkbox" id="signatureRequired">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="defaultPaymentOption" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.defaultPaymentOption") }}</label>
            <div class="col-sm-8">
              <Multiselect id="defaultPaymentOption"
                           v-model="form.defaultPaymentOption"
                           :options="store.getters['currencyMethods/options']()"
                           :custom-label="(opt:any) => helper.trans(`payment_options.${opt}`)"
                           :multiple="false"
                           select-label="Select"
                           :placeholder="helper.trans('labels.payment_option')"
              >
              </Multiselect>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="defaultPaymentSystem" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.defaultPaymentSystem") }}</label>
            <div class="col-sm-8">
              <Multiselect id="defaultPaymentSystem"
                           v-model="form.defaultPaymentSystem"
                           :options="['HUMO', 'UZCARD']"
                           :custom-label="(opt:any) => helper.trans(`payment_systems.${opt}`)"
                           :multiple="false"
                           select-label="Select"
                           :placeholder="helper.trans('labels.payment_system')"
              >
              </Multiselect>
            </div>
          </div>


          <div class="row mt-2" v-if="isAdmin">
            <label for="allowedPaymentOptions" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.allowedPaymentOptions") }}</label>
            <div class="col-sm-8">
              <Multiselect id="pay-out-methods"
                           v-model="form.allowedPaymentOptions"
                           :options="store.getters['currencyMethods/options']()"
                           :custom-label="(opt:any) => helper.trans(`payment_options.${opt}`)"
                           :multiple="true"
                           select-label="Select"
                           :placeholder="helper.trans('labels.payment_options')"
              >
              </Multiselect>
            </div>
          </div>


          <div class="row mt-2" v-if="isAdmin">
            <label for="allowedPaymentMethod" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.allowedPaymentMethod") }}</label>
            <div class="col-sm-8">
              <Multiselect id="pay-out-methods"
                           v-model="form.allowedPaymentMethod"
                           :options="methodList()"
                           :custom-label="(opt:any) => helper.trans(`pay_methods.${opt}`)"
                           :multiple="true"
                           select-label="Select"
                           :placeholder="helper.trans('labels.allowedPaymentMethodOptions')"
              >
                <template #option="props">
                  <div class="d-flex flex-row align-items-center gap-2">
                    <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                    <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                  </div>
                </template>
              </Multiselect>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="blacklistPaymentMethods" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.blacklistPaymentMethods") }}</label>
            <div class="col-sm-8">
              <Multiselect id="pay-out-methods"
                           v-model="form.blacklistPaymentMethods"
                           :options="methodList()"
                           :custom-label="(opt:any) => helper.trans(`pay_methods.${opt}`)"
                           :multiple="true"
                           select-label="Select"
                           :placeholder="helper.trans('labels.blacklistPaymentMethodsOptions')"
              >
                <template #option="props">
                  <div class="d-flex flex-row align-items-center gap-2">
                    <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                    <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                  </div>
                </template>
              </Multiselect>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="allowedPayoutMethods" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.allowedPayoutMethods") }}</label>
            <div class="col-sm-8">
              <Multiselect id="pay-out-methods"
                           v-model="form.allowedPayoutMethods"
                           :options="methodList()"
                           :custom-label="(opt:any) => helper.trans(`pay_methods.${opt}`)"
                           :multiple="true"
                           select-label="Select"
                           :placeholder="helper.trans('labels.allowedPaymentMethodsOptions')"
              >
                <template #option="props">
                  <div class="d-flex flex-row align-items-center gap-2">
                    <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                    <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                  </div>
                </template>
              </Multiselect>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isOnlySingleConcurrentDealAllowedForUser" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isOnlySingleConcurrentDealAllowedForUser") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isOnlySingleConcurrentDealAllowedForUser" class="form-check-input" type="checkbox" id="isOnlySingleConcurrentDealAllowedForUser">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin && userWhitelistFeatureEnabled">
            <label for="isUserWhitelistEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isUserWhitelistEnabled") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isUserWhitelistEnabled" class="form-check-input" type="checkbox" id="isUserWhitelistEnabled">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin && userWhitelistFeatureEnabled">
            <label for="userWhitelistText" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.userWhitelist") }}</label>
            <div class="col-sm-8">
              <textarea
                v-model="form.userWhitelistText"
                class="form-control font-monospace"
                id="userWhitelistText"
                rows="6"
                spellcheck="false"
                placeholder='["user-1", "user-2"]'
              ></textarea>
              <small class="form-text text-muted">{{ helper.trans("labels.userWhitelistHint") }}</small>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="stripRequisitesSpaces" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.stripRequisitesSpaces") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.stripRequisitesSpaces" class="form-check-input" type="checkbox" id="stripRequisitesSpaces">
              </div>
            </div>
          </div>
        </div>

        <div :class="activeTab !== Tabs.paymentPage ? ['d-none'] : []">
          <div class="row mt-2" v-if="isAdmin">
            <label for="flowType" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.flowType") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="[]">
                <Multiselect id="parentId"
                             class=""
                             :class="parentProps.class"
                             v-model="form.flowType"
                             :options="Object.values(FlowType)"
                             :custom-label="(opt) => helper.trans(`flow_types.${opt}`)"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isTrxIdRequiredForConfirm" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isTrxIdRequiredForConfirm") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isTrxIdRequiredForConfirm" class="form-check-input" type="checkbox" id="isTrxIdRequiredForConfirm">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="hideUploadReceipt" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.hideUploadReceipt") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.hideUploadReceipt" class="form-check-input" type="checkbox" id="hideUploadReceipt">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="receiptPdfRequired" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.receiptPdfRequired") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.receiptPdfRequired" class="form-check-input" type="checkbox" id="receiptPdfRequired">
              </div>
              <div v-if="form.receiptPdfRequired && form.hideUploadReceipt" class="form-text text-warning">{{ helper.trans("labels.receiptPdfRequiredConflict") }}</div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="showTpayWarning" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.showTpayWarning") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.showTpayWarning" class="form-check-input" type="checkbox" id="showTpayWarning">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="vietQrMobileSaveFlow" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.vietQrMobileSaveFlow") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.vietQrMobileSaveFlow" class="form-check-input" type="checkbox" id="vietQrMobileSaveFlow">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin && vietQrVndAmountWarningEnabled">
            <label for="vietQrVndAmountWarning" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.vietQrVndAmountWarning") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.vietQrVndAmountWarning" class="form-check-input" type="checkbox" id="vietQrVndAmountWarning">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="requestUserPhone" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.requestUserPhone") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.requestUserPhone" class="form-check-input" type="checkbox" id="requestUserPhone">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="paymentPageLayout" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.paymentPageLayout") }}</label>
            <div class="col-sm-8">
              <select
                id="paymentPageLayout"
                class="form-select"
                :value="form.paymentPageSettings?.layout ?? ''"
                @change="onPaymentPageLayoutChange(($event.target as HTMLSelectElement).value)"
              >
                <option value="">{{ helper.trans('payment_page_layouts.default') }}</option>
                <option v-for="layout in availablePaymentPageLayouts" :key="layout.id" :value="layout.id">
                  {{ helper.trans('payment_page_layouts.' + layout.id) }}
                </option>
              </select>
              <small v-if="selectedPaymentPageLayoutConditions" class="form-text text-muted d-block">
                {{ selectedPaymentPageLayoutConditions }}
              </small>
              <small class="form-text text-muted">{{ helper.trans('labels.paymentPageLayoutHint') }}</small>
              <div v-if="selectedPaymentPageLayoutPreviews.length" class="mt-2">
                <button type="button" class="btn btn-sm btn-outline-secondary" @click="openPaymentPageLayoutPreview">
                  <i class="fa fa-eye me-1"></i>{{ helper.trans('payment_instructions.design_preview') }}
                </button>
                <div v-if="paymentPageLayoutPreviewVisible" class="mt-2">
                  <img :src="selectedPaymentPageLayoutPreviews[0].src" class="img-fluid rounded border" alt="">
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3" v-if="isAdmin && form.flowType === FlowType.DEFAULT">
            <label class="col-sm-4 col-form-label text-capitalize-first">
              {{ helper.trans("labels.paymentPageBanks") }}
              <span v-if="isPaymentPageBanksDirty" class="badge bg-warning text-dark ms-1">{{ helper.trans("labels.paymentPageBanksUnsaved") }}</span>
            </label>
            <div class="col-sm-8">
              <div class="d-flex flex-wrap gap-2 mb-2">
                <button type="button" class="btn btn-outline-secondary btn-sm" @click="selectAllPaymentPageBanks">{{ helper.trans('button.select_all') }}</button>
                <button type="button" class="btn btn-outline-secondary btn-sm" @click="clearPaymentPageBanks">{{ helper.trans('button.clear_selection') }}</button>
                <button type="button" class="btn btn-outline-primary btn-sm" @click="$emit('save')">{{ helper.trans('button.save') }}</button>
              </div>
              <div class="payment-page-banks-list">
                <label
                  class="payment-page-banks-item"
                  v-for="method in paymentPageBankOptions"
                  :key="method"
                  :for="'paymentPageBank-' + method"
                >
                  <input
                    class="form-check-input m-0 flex-shrink-0"
                    type="checkbox"
                    :id="'paymentPageBank-' + method"
                    :value="method"
                    v-model="form.paymentPageSettings.banks"
                  >
                  <PayMethodIcon icon-class="pay-method-icon" :method="method"></PayMethodIcon>
                  <span>{{ helper.trans('pay_methods.' + method) }}</span>
                </label>
              </div>
              <small class="form-text text-muted">{{ helper.trans('labels.paymentPageBanksHint') }}</small>
            </div>
          </div>


        </div>
        <div :class="activeTab !== Tabs.disputes ? ['d-none'] : []">

          <div class="row mt-2" v-if="isAdmin">
            <label for="disputeOpeningPeriod" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.disputeOpeningPeriod") }}</label>
            <div class="col-sm-4">
              <input v-model="form.disputeOpeningPeriod" type="text" class="form-control"  id="disputeOpeningPeriod" placeholder="P14D или null">
              <small class="form-text text-muted">Пример: P14D</small>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isDisputeReopenAllowed" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isDisputeReopenAllowed") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isDisputeReopenAllowed" class="form-check-input" type="checkbox" id="isDisputeReopenAllowed">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isDisputeAmountChecked" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isDisputeAmountChecked") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isDisputeAmountChecked" class="form-check-input" type="checkbox" id="isDisputeAmountChecked">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isDisputeOnCompletedDealsAllowed" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isDisputeOnCompletedDealsAllowed") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isDisputeOnCompletedDealsAllowed" class="form-check-input" type="checkbox" id="isDisputeOnCompletedDealsAllowed">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isDisputeOpeningByApiDisabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isDisputeOpeningByApiDisabled") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isDisputeOpeningByApiDisabled" class="form-check-input" type="checkbox" id="isDisputeOpeningByApiDisabled">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin && !form.isDisputeOnCompletedDealsAllowed">
            <label for="isAdminOnlyDisputeOnCompleted" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isAdminOnlyDisputeOnCompleted") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isAdminOnlyDisputeOnCompleted" class="form-check-input" type="checkbox" id="isAdminOnlyDisputeOnCompleted">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="disputeAutoclosePeriod" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.disputeAutoclosePeriod") }}</label>
            <div class="col-sm-4">
              <input v-model="form.disputeAutoclosePeriod" type="text" class="form-control" id="disputeAutoclosePeriod" placeholder="PT30M">
              <small class="form-text text-muted">Пример: PT30M</small>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isAutoDisputeOnExpireEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isAutoDisputeOnExpireEnabled") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isAutoDisputeOnExpireEnabled" class="form-check-input" type="checkbox" id="isAutoDisputeOnExpireEnabled">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isCancelOnDisputeAutocloseEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isCancelOnDisputeAutocloseEnabled") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isCancelOnDisputeAutocloseEnabled" class="form-check-input" type="checkbox" id="isCancelOnDisputeAutocloseEnabled">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin && expiredOnDealTimeoutEnabled">
            <label for="isExpiredOnDealTimeoutEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isExpiredOnDealTimeoutEnabled") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isExpiredOnDealTimeoutEnabled" class="form-check-input" type="checkbox" id="isExpiredOnDealTimeoutEnabled">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="isAutoDisputeOnExpireReceiptRequired" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isAutoDisputeOnExpireReceiptRequired") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input
                  v-model="form.isAutoDisputeOnExpireReceiptRequired"
                  class="form-check-input"
                  type="checkbox"
                  id="isAutoDisputeOnExpireReceiptRequired"
                  :disabled="!form.isAutoDisputeOnExpireEnabled"
                >
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="autoDisputeOnExpirePeriod" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.autoDisputeOnExpirePeriod") }}</label>
            <div class="col-sm-4">
              <input
                v-model="form.autoDisputeOnExpirePeriod"
                type="text"
                class="form-control"
                id="autoDisputeOnExpirePeriod"
                placeholder="PT15M"
                :disabled="!form.isAutoDisputeOnExpireEnabled"
              >
              <small class="form-text text-muted">Пример: PT15M. Пусто — обычный период автозакрытия спора</small>
            </div>
          </div>

          <div class="row mt-2" v-if="isAdmin">
            <label for="nightShiftHours" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.nightShiftHours") }}</label>
            <div class="col-sm-8">
              <Multiselect
                  v-model="form.nightShiftHours"
                  :options="hoursOptions"
                  :multiple="true"
                  :close-on-select="false"
                  :placeholder="'Выберите часы ночной смены'"
                  :custom-label="(opt:any) => opt"
              >
              </Multiselect>
            </div>
          </div>

        </div>

      </div>
    </div>

  </form>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from "vue";
import {useStore} from "vuex";
import {$t, helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import Multiselect from "vue-multiselect";
import MerchantStoreFormDTO, {CrossBorderSettingRowFormDTO, MerchantStoreTrafficGroupFormDTO, ReferralStoreSettingRowFormDTO} from "@/models/form/MerchantStoreFormDTO";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import {api} from "@/service/APIClient";
import {Direction} from "@/models/enum/Direction";
import MerchantStoreUpdateRequestDTO from "@/models/request/MerchantStoreUpdateRequestDTO";
import PaymentPageLayoutDTO from "@/models/PaymentPageLayoutDTO";
import CrossBorderSettingDTO from "@/models/CrossBorderSettingDTO";
import ReferralStoreSettingDTO, {REFERRAL_SLOTS, referralSlotKey} from "@/models/ReferralStoreSettingDTO";
import MerchantDTO from "@/models/MerchantDTO";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import {useNotification} from "@kyvg/vue3-notification";
import {Dictionary} from "@/types";
import {FlowType} from "@/models/enum/FlowType";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import {normalizeHttpValidationErrors} from "@/service/normalizeHttpValidationErrors";
import {
  getEffectiveIssuanceAlertChatId,
  ISSUANCE_ALERT_FIELDS,
  readIssuanceAlertFromLegacyConfig,
  stripIssuanceAlertFromConfig,
} from "@/service/merchantStoreIssuanceAlert";

const notification = useNotification()

const parseCriticalMilliseconds = (value: string | null | undefined): number =>
  Number.parseInt((value ?? '').replace(/\s/g, ''), 10);

const parseUserWhitelist = (text: string | null | undefined): string[] | null => {
  const trimmed = (text ?? '').trim();
  if (trimmed === '') {
    return [];
  }

  let parsed: unknown;
  try {
    parsed = JSON.parse(trimmed);
  } catch (e) {
    return null;
  }

  if (!Array.isArray(parsed) || !parsed.every((item) => typeof item === 'string' || Number.isSafeInteger(item))) {
    return null;
  }

  return parsed.map((item) => String(item));
};

// пустые кросс-бордер настройки приезжают с бэка как [] (PHP-массив), непустые — как объект
const toCrossBorderRows = (value: unknown): CrossBorderSettingRowFormDTO[] => {
  if (!value || typeof value !== 'object') {
    return [];
  }
  if (Array.isArray(value)) {
    return value as CrossBorderSettingRowFormDTO[];
  }
  return Object.entries(value as Record<string, CrossBorderSettingDTO>).map(([currency, item]) => ({
    currency,
    source: item?.source ?? null,
    payInRateSource: item?.payInRateSource ?? null,
    gap: item?.gap !== null && item?.gap !== undefined ? String(item.gap) : null,
    automationGap: item?.automationGap !== null && item?.automationGap !== undefined ? String(item.automationGap) : null,
    gapAmount: item?.gapAmount !== null && item?.gapAmount !== undefined ? String(item.gapAmount) : null,
    step: item?.step !== null && item?.step !== undefined ? String(item.step) : null,
  }));
};

const toReferralRows = (
  merchant: MerchantDTO | null | undefined,
  settings: unknown,
): ReferralStoreSettingRowFormDTO[] => {
  if (!merchant) {
    return [];
  }

  const overrides = (settings && typeof settings === 'object' && !Array.isArray(settings)
    ? settings
    : {}) as Record<string, ReferralStoreSettingDTO>;

  const rows: ReferralStoreSettingRowFormDTO[] = [];
  for (const slot of REFERRAL_SLOTS) {
    const source = merchant as unknown as Record<string, any>;
    const prefix = slot === 1 ? 'referral' : `referral${slot}`;

    const merchantPayInFee = helper.floatToPercent(String(source[`${prefix}PayInFee`] ?? '0'));
    const merchantPayOutFee = helper.floatToPercent(String(source[`${prefix}PayOutFee`] ?? '0'));
    const merchantPayInFeeType = Number(source[`${prefix}PayInFeeType`] ?? 0);
    const merchantPayOutFeeType = Number(source[`${prefix}PayOutFeeType`] ?? 0);

    const override = overrides[referralSlotKey(slot)] ?? {};
    const referralId = override.referralId !== undefined && override.referralId !== null
      ? Number(override.referralId)
      : null;

    rows.push({
      slot,
      referralId,
      referralUser: null,
      payInFee: override.payInFee !== undefined && override.payInFee !== null
        ? String(helper.floatToPercent(String(override.payInFee)))
        : null,
      payInFeeType: override.payInFeeType !== undefined && override.payInFeeType !== null
        ? Number(override.payInFeeType)
        : merchantPayInFeeType,
      payOutFee: override.payOutFee !== undefined && override.payOutFee !== null
        ? String(helper.floatToPercent(String(override.payOutFee)))
        : null,
      payOutFeeType: override.payOutFeeType !== undefined && override.payOutFeeType !== null
        ? Number(override.payOutFeeType)
        : merchantPayOutFeeType,
      merchantPayInFee: String(merchantPayInFee),
      merchantPayInFeeType,
      merchantPayOutFee: String(merchantPayOutFee),
      merchantPayOutFeeType,
    });
  }

  return rows;
};

const components = {
  Multiselect,
  FormInputWrapper,
  PayMethodIcon,
}

enum Tabs {
  main = 'main',
  rates = 'rates',
  api = 'api',
  disputes = 'disputes',
  payouts = 'payouts',
  paymentPage = 'paymentPage',
  config = 'config'
}

export default defineComponent({
  methods: {$t},
  props: {},
  emits: ['open-settings-history', 'open-cross-border-rates', 'open-referral-settings', 'save'],
  components,
  setup() {
    const configField = ref<InstanceType<any> | null>(null)
    const issuanceTimeAlertTgChatIdDirty = ref(false)
    const store = useStore();
    const paymentPageBankOptions = [
      'sberbank',
      'tinkoff',
      'alfabank',
      'vtb',
      'gazprombank',
      'promsvyaz',
      'ozon',
      'sovkom',
      'wbbank',
    ]
    const paymentPageBanksSnapshot = ref<string[]>([]);
    const paymentPageLayouts = ref<PaymentPageLayoutDTO[]>([]);
    const paymentPageLayoutPreviewVisible = ref(false);
    const PAYMENT_PAGE_LAYOUT_PREVIEWS: Record<string, {src: string}[]> = {
      psb_cross_border: [
        {src: require('@/assets/img/payment-page-previews/psb-cross-border-mobile-1.jpg')},
      ],
      alfa_c2c_cross_border: [
        {src: require('@/assets/img/payment-page-previews/alfa-c2c-cross-border-mobile.jpg')},
      ],
      kazakhstan_cross_border: [
        {src: require('@/assets/img/payment-page-previews/kazakhstan-cross-border-mobile.jpg')},
      ],
    };
    const state = reactive({
      activeTab: Tabs.main as Tabs,
      form: {} as MerchantStoreFormDTO,
      expandedRanges: {} as Dictionary<boolean>,
      issuanceAlertErrors: [] as ValidationErrorDTO[],
      crossBorderErrors: [] as ValidationErrorDTO[],
      referralErrors: [] as ValidationErrorDTO[],
    });

    const referralOverridesCount = computed<number>(() =>
      (state.form.referralSettings ?? []).filter((row) =>
        row.referralId !== null
        || (row.payInFee !== null && row.payInFee !== '')
        || (row.payOutFee !== null && row.payOutFee !== '')
      ).length
    );

    const canManageIssuanceAlert = computed(() => store.getters.isAdmin || store.getters.isOperator);

    const getIssuanceAlertErrors = (field: string) =>
      state.issuanceAlertErrors.filter((item) => item.field === field);

    const setIssuanceAlertErrors = (data: unknown) => {
      const errors = normalizeHttpValidationErrors(data);
      state.issuanceAlertErrors = errors.filter((item) => ISSUANCE_ALERT_FIELDS.has(item.field));
    };

    const getCrossBorderErrors = (): ValidationErrorDTO[] => state.crossBorderErrors;
    const getReferralErrors = (): ValidationErrorDTO[] => state.referralErrors;

    const setCrossBorderSettings = (rows: CrossBorderSettingRowFormDTO[]) => {
      state.form.crossBorderSettings = rows;
      state.crossBorderErrors = [];
    };

    const setReferralSettings = (rows: ReferralStoreSettingRowFormDTO[]) => {
      state.form.referralSettings = rows;
      state.referralErrors = [];
    };

    // ошибки crossBorderSettings.* / referralSettings.* показываем нотификацией: модалка в момент ответа уже закрыта
    const handleSaveErrors = (data: unknown) => {
      const errors = normalizeHttpValidationErrors(data);
      state.issuanceAlertErrors = errors.filter((item) => ISSUANCE_ALERT_FIELDS.has(item.field));
      state.crossBorderErrors = errors.filter((item) => (item.field ?? '').startsWith('crossBorderSettings'));
      state.referralErrors = errors.filter((item) => (item.field ?? '').startsWith('referralSettings'));

      for (const error of errors) {
        if (ISSUANCE_ALERT_FIELDS.has(error.field)) {
          continue;
        }
        notification.notify({
          type: 'error',
          title: helper.trans('labels.error'),
          text: error.message,
        });
      }
    };

    const markIssuanceTimeAlertTgChatIdDirty = () => {
      issuanceTimeAlertTgChatIdDirty.value = true;
    };

    const buildStoreConfig = (): Record<string, unknown> | null => {
      let config: Record<string, unknown> = {};
      const configValue = configField.value?.value;
      if (store.getters.isAdmin && configValue) {
        try {
          const parsedConfig = JSON.parse(configValue);
          config = parsedConfig && typeof parsedConfig === 'object' && !Array.isArray(parsedConfig)
            ? parsedConfig
            : {};
        } catch (e) {
          notification.notify({type: 'error', title: helper.trans('labels.error'), text: helper.trans('labels.invalid_json')});
          return null;
        }
      } else {
        const formConfig = state.form.config;
        config = formConfig && typeof formConfig === 'object' && !Array.isArray(formConfig)
          ? {...formConfig}
          : {};
      }
      return stripIssuanceAlertFromConfig(config);
    };

    const save = () => {
      const form = getForm();
      state.issuanceAlertErrors = [];

      if (canManageIssuanceAlert.value && form.issuanceTimeAlertEnabled) {
        const milliseconds = parseCriticalMilliseconds(form.issuanceTimeAlertCriticalMilliseconds);
        if (!milliseconds || milliseconds <= 0) {
          notification.notify({
            type: 'error',
            title: helper.trans('labels.error'),
            text: helper.trans('store.issuance_time_alert.critical_milliseconds_invalid'),
          });
          return null;
        }
        if (!getEffectiveIssuanceAlertChatId(form.issuanceTimeAlertTgChatId, state.form.merchant?.tgChatGroupId)) {
          notification.notify({
            type: 'error',
            title: helper.trans('labels.error'),
            text: helper.trans('store.issuance_time_alert.chat_required'),
          });
          return null;
        }
      }

      const userWhitelistFeatureEnabled = !!store.getters.isAdmin && !!store.getters.getAppData?.STORE_USER_WHITELIST_ENABLED;
      let userWhitelist: string[] = [];
      if (userWhitelistFeatureEnabled) {
        const parsedUserWhitelist = parseUserWhitelist(form.userWhitelistText);
        if (parsedUserWhitelist === null) {
          notification.notify({type: 'error', title: helper.trans('labels.error'), text: helper.trans('labels.userWhitelistInvalid')});
          return null;
        }
        userWhitelist = parsedUserWhitelist;
      }

      let limits = {} as Dictionary<string>
      for (const item of form.payInRequestLimits) {
        limits[!item.option ? 'any' : item.option] = helper.percentToFloat(item.value)
      }

      const payInRequestLimitsByAmountEnabled = !!store.getters.getAppData?.PAY_IN_REQUEST_LIMITS_BY_AMOUNT_ENABLED;
      const payInRequestLimitsByAmount: Array<{minSum: number; maxSum: number; limit: string}> = []
      if (payInRequestLimitsByAmountEnabled) {
        for (const row of form.payInRequestLimitsByAmount ?? []) {
          const minRaw = row.minSum !== null && row.minSum !== undefined ? String(row.minSum).trim() : ''
          const maxRaw = row.maxSum !== null && row.maxSum !== undefined ? String(row.maxSum).trim() : ''
          const valueRaw = row.value !== null && row.value !== undefined ? String(row.value).trim() : ''
          if (minRaw === '' && maxRaw === '' && valueRaw === '') {
            continue
          }
          if (minRaw === '' || maxRaw === '' || valueRaw === '') {
            notification.notify({type: 'error', title: helper.trans('labels.error'), text: helper.trans('labels.payInRequestLimitByAmountIncomplete')});
            return null
          }
          const minSum = Math.round(parseFloat(minRaw) * 100)
          const maxSum = Math.round(parseFloat(maxRaw) * 100)
          if (!Number.isFinite(minSum) || !Number.isFinite(maxSum) || minSum >= maxSum) {
            notification.notify({type: 'error', title: helper.trans('labels.error'), text: helper.trans('labels.payInRequestLimitByAmountInvalidRange')});
            return null
          }
          payInRequestLimitsByAmount.push({
            minSum,
            maxSum,
            limit: helper.percentToFloat(valueRaw),
          })
        }
        for (let i = 0; i < payInRequestLimitsByAmount.length; i++) {
          for (let j = i + 1; j < payInRequestLimitsByAmount.length; j++) {
            const a = payInRequestLimitsByAmount[i]
            const b = payInRequestLimitsByAmount[j]
            if (a.minSum <= b.maxSum && b.minSum <= a.maxSum) {
              notification.notify({type: 'error', title: helper.trans('labels.error'), text: helper.trans('labels.payInRequestLimitByAmountOverlap')});
              return null
            }
          }
        }
      }

      const config = buildStoreConfig();
      if (config === null) {
        return null;
      }

      // проценты уходят на бэк как есть (3 = 3%), percentToFloat здесь применять нельзя
      const crossBorderSettings = {} as Record<string, CrossBorderSettingDTO>;
      for (const row of form.crossBorderSettings ?? []) {
        if (!row.currency) {
          continue;
        }
        const item: CrossBorderSettingDTO = {};
        if (row.source) item.source = row.source;
        if (row.payInRateSource) item.payInRateSource = row.payInRateSource;
        // 0 — валидное значение для automationGap (коридор выключен); truthy-проверка его выкинет
        if (row.gap !== null && row.gap !== undefined && String(row.gap).trim() !== '') {
          item.gap = Number(row.gap);
        }
        if (row.automationGap !== null && row.automationGap !== undefined && String(row.automationGap).trim() !== '') {
          item.automationGap = Number(row.automationGap);
        }
        if (row.gapAmount !== null && row.gapAmount !== undefined && String(row.gapAmount).trim() !== '') {
          item.gapAmount = Number(row.gapAmount);
        }
        if (row.step !== null && row.step !== undefined && String(row.step).trim() !== '') {
          item.step = Number(row.step);
        }
        if (Object.keys(item).length > 0) {
          crossBorderSettings[row.currency] = item;
        }
      }

      const referralSettings = {} as Record<string, ReferralStoreSettingDTO>;
      for (const row of form.referralSettings ?? []) {
        const item: ReferralStoreSettingDTO = {};
        if (row.referralId !== null) {
          item.referralId = row.referralId;
        }
        if (row.payInFee !== null && row.payInFee !== '') {
          item.payInFee = helper.percentToFloat(row.payInFee);
          item.payInFeeType = row.payInFeeType;
        }
        if (row.payOutFee !== null && row.payOutFee !== '') {
          item.payOutFee = helper.percentToFloat(row.payOutFee);
          item.payOutFeeType = row.payOutFeeType;
        }
        if (Object.keys(item).length > 0) {
          referralSettings[referralSlotKey(row.slot)] = item;
        }
      }

      const requestForm = {...form} as any;
      delete requestForm.merchant;
      delete requestForm.crossBorderSettings;
      delete requestForm.referralSettings;
      delete requestForm.issuanceTimeAlertEnabled;
      delete requestForm.issuanceTimeAlertCriticalMilliseconds;
      delete requestForm.issuanceTimeAlertTgChatId;
      delete requestForm.payInFeeByPaymentOption;
      delete requestForm.isUserWhitelistEnabled;
      delete requestForm.userWhitelist;
      delete requestForm.userWhitelistText;
      delete requestForm.payOutDealSla;

      const geoFeeEnabled = !!store.getters.getAppData?.PAY_IN_FEE_BY_PAYMENT_OPTION_ENABLED;
      const payOutDealSlaFeatureEnabled = !!store.getters.isAdmin && !!store.getters.getAppData?.PAY_OUT_DEAL_SLA_ENABLED;

      const data = {
        ...requestForm,
        // не-админ настройки не видит: не отправляем поле вовсе, иначе {} их очистит
        ...(store.getters.isAdmin ? {crossBorderSettings, referralSettings} : {}),
        ...(userWhitelistFeatureEnabled ? {isUserWhitelistEnabled: !!form.isUserWhitelistEnabled, userWhitelist} : {}),
        ...(payOutDealSlaFeatureEnabled ? {payOutDealSla: (form.payOutDealSla ?? '').trim()} : {}),
        config: config as any,
        issuanceTimeAlertEnabled: !!form.issuanceTimeAlertEnabled,
        issuanceTimeAlertCriticalMilliseconds: form.issuanceTimeAlertEnabled
          ? parseCriticalMilliseconds(form.issuanceTimeAlertCriticalMilliseconds)
          : null,
        dealTimeOutMin: form.dealTimeOutMin ? parseInt(form.dealTimeOutMin) : null,
        payInRequestLimits: limits,
        ...(payInRequestLimitsByAmountEnabled ? {payInRequestLimitsByAmount} : {}),
        payInFee: form.payInFee ? Math.round(parseFloat(form.payInFee!) * 10000) / 1000000 : null,
        ...(geoFeeEnabled ? {
          payInFeeByPaymentOption: (form.payInFeeByPaymentOption ?? []).reduce((acc, row) => {
            if (row.option === null || row.option === undefined || row.option === '') {
              return acc;
            }
            if (row.feePercent === null || row.feePercent === undefined || String(row.feePercent).trim() === '') {
              return acc;
            }
            acc[row.option] = helper.percentToFloat(row.feePercent);
            return acc;
          }, {} as Record<string, string>),
        } : {}),
        payOutFee: form.payOutFee ? Math.round(parseFloat(form.payOutFee!) * 10000) / 1000000 : null,
        payInRateShift: form.payInRateShift === '' || form.payInRateShift === null || !form.payInRateShift ? null : helper.percentToFloat(form.payInRateShift),
        payOutFixedRate: form.payOutFixedRate === '' || form.payOutFixedRate === null ? null : Number.parseFloat((form.payOutFixedRate ?? '')!.replace(/\s/g, '')),
        reusablePaymentsCountLimit: form.reusablePaymentsCountLimit === '' || form.reusablePaymentsCountLimit === null || form.reusablePaymentsCountLimit === undefined
          ? null
          : Number.parseInt(form.reusablePaymentsCountLimit.replace(/\s/g, '')),
        minPayInAmount: form.minPayInAmount === '' || form.minPayInAmount === null ? null : Number.parseInt(form.minPayInAmount!.replace(/\s/g, '')),
        maxPayInAmount: form.maxPayInAmount === '' || form.maxPayInAmount === null ? null : Number.parseInt(form.maxPayInAmount!.replace(/\s/g, '')),
        minPayOutAmount: form.minPayOutAmount === '' || form.minPayOutAmount === null ? null : Number.parseInt(form.minPayOutAmount!.replace(/\s/g, '')),
        maxPayOutAmount: form.maxPayOutAmount === '' || form.maxPayOutAmount === null ? null : Number.parseInt(form.maxPayOutAmount!.replace(/\s/g, '')),
        trafficGroups: form.trafficGroups.reduce((acc, item, index) => {
          if (item.trafficGroup?.id) {
            acc[item.trafficGroup.id] = {
              fee: item.fee ? helper.percentToFloat(item.fee) : null,
              feeByDealAmount: item.feeByDealAmount ? item.feeByDealAmount.map(range => ({
                minSum: range.minSum ? Math.round(parseFloat(range.minSum) * 100) : null,
                maxSum: range.maxSum ? Math.round(parseFloat(range.maxSum) * 100) : null,
                fee: range._feePercent ? helper.percentToFloat(range._feePercent) : null
              })) : null
            };
          }
          return acc;
        }, {} as any),
        nightShiftHours: form.nightShiftHours || null,
        disputeOpeningPeriod: form.disputeOpeningPeriod || null,
        payOutDealAcceptTimeout: form.payOutDealAcceptTimeout || null,
        payOutDealDisputeTimeout: form.payOutDealDisputeTimeout || null,
        payOutDealLifetimeTimeout: form.payOutDealLifetimeTimeout || null,
        isSingleTakePayOutEnabled: form.isSingleTakePayOutEnabled ?? null,
        integrationName: integrationNames.value?.length > 0 && !form.integrationName ? '' : form.integrationName
      } as MerchantStoreUpdateRequestDTO;

      if (issuanceTimeAlertTgChatIdDirty.value) {
        data.issuanceTimeAlertTgChatId = (form.issuanceTimeAlertTgChatId ?? '').trim();
      }

      let promise;

      if (!validatePeriod(form.disputeOpeningPeriod)) {
        return null;
      }

      if (!validatePeriod(form.disputeAutoclosePeriod)) {
        return null;
      }

      if (!validatePeriod(form.autoDisputeOnExpirePeriod || null)) {
        return null;
      }

      if (!validatePeriod(form.payOutDealAcceptTimeout)) {
        return null;
      }

      if (!validatePeriod(form.payOutDealDisputeTimeout)) {
        return null;
      }

      if (!validatePeriod(form.payOutDealLifetimeTimeout)) {
        return null;
      }

      if (form.id) {
        promise = api.updateStore(form.id, data);
      } else {
        promise = api.createStore(data);
      }

      return promise.then((resp) => {
        paymentPageBanksSnapshot.value = [...(state.form.paymentPageSettings?.banks ?? [])];
        return resp;
      });
    }

    const getForm = (): MerchantStoreFormDTO => {
      return state.form
    }

    const setForm = (form: MerchantStoreFormDTO) => {
      state.activeTab = Tabs.main
      if (form.trafficGroups) {
        form.trafficGroups = form.trafficGroups.map((item, index) => {
          if (!item.feeByDealAmount) {
            item.feeByDealAmount = []
          } else {
            item.feeByDealAmount = item.feeByDealAmount.map((range, rangeIndex) => {
              const newRange = {
                minSum: range.minSum !== null && range.minSum !== undefined ? range.minSum.toString() : '',
                maxSum: range.maxSum !== null && range.maxSum !== undefined ? range.maxSum.toString() : '',
                fee: range.fee || '',
                _feePercent: range.fee ? helper.floatToPercent(range.fee) : 0,
              }
              return newRange
            })
          }

          return item;
        });
      }

      if (configField.value) {
        configField.value.value = JSON.stringify(form.config ?? {}, null, 4)
      }
      const rawConfig = (form.config ?? {}) as Record<string, unknown>;
      const legacy = readIssuanceAlertFromLegacyConfig(rawConfig);
      const enabled = typeof form.issuanceTimeAlertEnabled === 'boolean'
        ? form.issuanceTimeAlertEnabled
        : legacy.enabled;

      let criticalMilliseconds: string | null = null;
      if (form.issuanceTimeAlertCriticalMilliseconds != null && form.issuanceTimeAlertCriticalMilliseconds !== '') {
        criticalMilliseconds = String(form.issuanceTimeAlertCriticalMilliseconds);
      } else if (legacy.milliseconds != null) {
        criticalMilliseconds = String(legacy.milliseconds);
      }

      issuanceTimeAlertTgChatIdDirty.value = false;
      const paymentPageBanks = [...(form.paymentPageSettings?.banks ?? [])]
        .filter((method) => paymentPageBankOptions.includes(method));
      state.form = {
        ...form,
        config: stripIssuanceAlertFromConfig(rawConfig),
        issuanceTimeAlertEnabled: !!enabled,
        issuanceTimeAlertCriticalMilliseconds: criticalMilliseconds,
        issuanceTimeAlertTgChatId: form.issuanceTimeAlertTgChatId ?? '',
        crossBorderSettings: toCrossBorderRows(form.crossBorderSettings),
        referralSettings: toReferralRows(form.merchant, form.referralSettings),
        paymentPageSettings: {
          banks: paymentPageBanks,
          layout: form.paymentPageSettings?.layout ?? null,
        },
        payInFeeByPaymentOption: (form.payInFeeByPaymentOption ?? []).map((item) => ({...item})),
        payInRequestLimitsByAmount: (form.payInRequestLimitsByAmount ?? []).map((row) => ({...row})),
      }
      paymentPageBanksSnapshot.value = [...paymentPageBanks];
      state.issuanceAlertErrors = [];
      state.crossBorderErrors = [];
      state.referralErrors = [];

      if (form.trafficGroups && form.trafficGroups.length > 0) {
        form.trafficGroups.forEach((item, index) => {
          if (item.feeByDealAmount && item.feeByDealAmount.length > 0) {
            state.expandedRanges[index] = true;
          }
        });
      }
    }

    const addTrafficGroup = () => {
      state.form.trafficGroups.push({
        trafficGroup: null,
        fee: null,
        feeByDealAmount: []
      } as MerchantStoreTrafficGroupFormDTO)
    }

    const addLimit = () => {
      state.form.payInRequestLimits.push({
        option: null,
        value: null
      })
    }

    const addPayInRequestLimitByAmount = () => {
      if (!state.form.payInRequestLimitsByAmount) {
        state.form.payInRequestLimitsByAmount = []
      }
      state.form.payInRequestLimitsByAmount.push({
        minSum: '',
        maxSum: '',
        value: null,
      })
    }

    const removePayInRequestLimitByAmount = (index: number) => {
      state.form.payInRequestLimitsByAmount = (state.form.payInRequestLimitsByAmount ?? []).filter((_item, itemIndex) => itemIndex !== index)
    }

    const addPayInFeeOption = () => {
      state.form.payInFeeByPaymentOption.push({
        option: null,
        feePercent: null
      })
    }

    const removePayInFeeOption = (index: number) => {
      state.form.payInFeeByPaymentOption = (state.form.payInFeeByPaymentOption ?? []).filter((_item, itemIndex) => itemIndex !== index);
    }

    const removeTrafficGroup = (index:number) => {
      state.form.trafficGroups = state.form.trafficGroups.filter((item, itemIndex) => itemIndex !== index);
      delete state.expandedRanges[index];
    }

    const toggleRanges = (index: number) => {
      state.expandedRanges[index] = !state.expandedRanges[index];
    };


    const addRange = (trafficGroupIndex: number) => {
      if (!state.form.trafficGroups[trafficGroupIndex].feeByDealAmount) {
        state.form.trafficGroups[trafficGroupIndex].feeByDealAmount = [];
      }
      state.form.trafficGroups[trafficGroupIndex].feeByDealAmount.push({
        minSum: null,
        maxSum: null,
        fee: null,
        _feePercent: null
      });
    }

    const removeRange = (trafficGroupIndex: number, rangeIndex: number) => {
      state.form.trafficGroups[trafficGroupIndex].feeByDealAmount.splice(rangeIndex, 1);
    }

    const isRangeValid = (range: any) => {
      if (!range.minSum && !range.maxSum) return false;
      if (range.minSum && range.maxSum && parseFloat(range.minSum) > parseFloat(range.maxSum)) return false;
      return true;
    }

    const updateRangeField = (trafficGroupIndex: number, rangeIndex: number, field: string, value: any) => {
      const range = state.form.trafficGroups[trafficGroupIndex].feeByDealAmount[rangeIndex];
      if (range) {
        (range as any)[field] = value;
        if (field === '_feePercent') {
          range.fee = helper.percentToFloat(value);
        }
      }
    }

    const removeLimit = (index:number) => {
      state.form.payInRequestLimits = state.form.payInRequestLimits.filter((item:any, itemIndex:number) => itemIndex !== index);
    }

    const hoursOptions = Array.from({ length: 24 }, (_, i) => i.toString());

    const validatePeriod = (period:string|null): boolean => {

      const iso8601Regex = /^P(?:(\d+Y)?(\d+M)?(\d+W)?(\d+D)?)(T(?:(\d+H)?(\d+M)?(\d+S)?)?)?$/;

      if (
          period === null ||
          period === "null" ||
          iso8601Regex.test(period)
      ) {
        return true;
      } else {
        notification.notify({title: helper.trans('store.dispute_validation.error')});
        return false;
      }
    };

    const integrationNames = computed((): string[] => store.getters.getAppData?.MERCHANT_INTEGRATION_NAMES)

    const normalizePaymentPageBanks = (banks: string[] | undefined | null): string[] => {
      return [...(banks ?? [])].slice().sort()
    }

    const isPaymentPageBanksDirty = computed<boolean>(() => {
      return JSON.stringify(normalizePaymentPageBanks(state.form.paymentPageSettings?.banks))
        !== JSON.stringify(normalizePaymentPageBanks(paymentPageBanksSnapshot.value))
    })

    const ensurePaymentPageSettings = (): {banks: string[], layout?: string | null} => {
      if (state.form.paymentPageSettings === undefined) {
        state.form.paymentPageSettings = {banks: [], layout: null}
      }

      return state.form.paymentPageSettings
    }

    const availablePaymentPageLayouts = computed(() => {
      const selected = state.form.paymentPageSettings?.layout
      return paymentPageLayouts.value.filter((layout) => layout.available || layout.id === selected)
    })

    const selectedPaymentPageLayoutConditions = computed(() => {
      const layoutId = state.form.paymentPageSettings?.layout
      if (!layoutId) {
        return ''
      }

      return paymentPageLayouts.value.find((layout) => layout.id === layoutId)?.conditions ?? ''
    })

    const selectedPaymentPageLayoutPreviews = computed(() => {
      const layoutId = state.form.paymentPageSettings?.layout
      return layoutId ? PAYMENT_PAGE_LAYOUT_PREVIEWS[layoutId] ?? [] : []
    })

    const onPaymentPageLayoutChange = (value: string) => {
      const settings = ensurePaymentPageSettings()
      settings.layout = value === '' ? null : value
      paymentPageLayoutPreviewVisible.value = false
    }

    const openPaymentPageLayoutPreview = () => {
      paymentPageLayoutPreviewVisible.value = !paymentPageLayoutPreviewVisible.value
    }

    onMounted(async () => {
      try {
        paymentPageLayouts.value = await api.paymentPageLayouts();
      } catch (e) {
        paymentPageLayouts.value = [];
      }
    })

    const selectAllPaymentPageBanks = () => {
      const settings = ensurePaymentPageSettings()
      settings.banks = [...paymentPageBankOptions]
    }

    const clearPaymentPageBanks = () => {
      const settings = ensurePaymentPageSettings()
      settings.banks = []
    }

    return {
      ...toRefs(state),
      getForm,
      setForm,
      store,
      helper,
      numberFormatter,
      isAdmin: computed<boolean>(() => store.getters.isAdmin),
      geoFeeEnabled: computed(() => !!store.getters.getAppData?.PAY_IN_FEE_BY_PAYMENT_OPTION_ENABLED),
      payInRequestLimitsByAmountEnabled: computed(() => !!store.getters.getAppData?.PAY_IN_REQUEST_LIMITS_BY_AMOUNT_ENABLED),
      expiredOnDealTimeoutEnabled: computed(() => !!store.getters.getAppData?.EXPIRED_ON_DEAL_TIMEOUT_ENABLED),
      userWhitelistFeatureEnabled: computed(() => !!store.getters.getAppData?.STORE_USER_WHITELIST_ENABLED),
      payOutDealSlaFeatureEnabled: computed(() => !!store.getters.getAppData?.PAY_OUT_DEAL_SLA_ENABLED),
      vietQrVndAmountWarningEnabled: computed(() => !!store.getters.getAppData?.VIET_QR_VND_AMOUNT_WARNING_ENABLED),
      canManageIssuanceAlert,
      markIssuanceTimeAlertTgChatIdDirty,
      getIssuanceAlertErrors,
      setIssuanceAlertErrors,
      handleSaveErrors,
      getCrossBorderErrors,
      setCrossBorderSettings,
      getReferralErrors,
      setReferralSettings,
      referralOverridesCount,
      Direction,
      save,
      removeTrafficGroup,
      addTrafficGroup,
      toggleRanges,
      addRange,
      removeRange,
      updateRangeField,
      isRangeValid,
      expandedRanges: state.expandedRanges,
      removeLimit,
      addLimit,
      addPayInRequestLimitByAmount,
      removePayInRequestLimitByAmount,
      addPayInFeeOption,
      removePayInFeeOption,
      hoursOptions,
      methodList: computed(() => store.getters["currencyMethods/methods"]),
      FlowType,
      Tabs,
      integrationNames,
      configField,
      paymentPageBankOptions,
      isPaymentPageBanksDirty,
      selectAllPaymentPageBanks,
      clearPaymentPageBanks,
      availablePaymentPageLayouts,
      selectedPaymentPageLayoutConditions,
      selectedPaymentPageLayoutPreviews,
      paymentPageLayoutPreviewVisible,
      onPaymentPageLayoutChange,
      openPaymentPageLayoutPreview,
    }
  },
  async beforeMount() {
    const store = useStore();
    try {
      await store.dispatch("currencyMethods/loadList");
      await store.dispatch("trafficGroups/loadList");
    } catch (e) {}

  }
})
</script>

<style scoped>
.payment-page-banks-list {
  max-height: 280px;
  overflow-y: auto;
}

.payment-page-banks-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  padding: 4px 8px;
  margin: 0;
  cursor: pointer;
}

.payment-page-banks-item :deep(img.pay-method-icon) {
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 24px;
  object-fit: cover;
}
</style>
